import React, { createContext, useContext, useEffect, useState } from "react";

const STR = {
  en: {
    tagline: "Broadcast. Engage. Sell.",
    hero_title: "Turn Every Live Into Revenue",
    hero_sub: "Yes Go Live combines a browser broadcast studio, an AI Producer, live commerce, unified comments and CRM lead attribution — one platform to go live and convert.",
    go_live: "GO LIVE NOW",
    get_started: "Get Started Free",
    login_google: "Continue with Google",
    nav_command: "Live Command",
    nav_studio: "Studio Console",
    nav_clips: "AI Clips",
    nav_battle: "Sales Battle",
    nav_leads: "Leads / CRM",
    nav_analytics: "Analytics",
    nav_pricing: "Pricing",
    logout: "Logout",
    live_now: "Live Now",
    total_viewers: "Total Viewers",
    engagement: "Engagement",
    leads: "Leads",
    sales: "Sales",
    revenue: "Revenue",
    host_performance: "Host Performance",
    revenue_7d: "Revenue (7 days)",
    active_sessions: "Sessions",
    open_studio: "Open Studio",
    new_studio: "New Studio",
    enter_studio: "ENTER STUDIO",
    prelive_lobby: "Pre-Live Lobby",
    camera: "Camera",
    microphone: "Microphone",
    speaker: "Speaker",
    mic_level: "Mic Level",
    echo: "Echo Cancellation",
    noise: "Noise Suppression",
    gain: "Auto Gain",
    scenes: "Scenes",
    ai_producer: "OTO AI Producer",
    ask_ai: "Ask AI Producer",
    comments: "Live Comments",
    commerce: "Live Commerce",
    audio_mixer: "Audio Mixer",
    show_product: "Show Product",
    show_cta: "Show CTA",
    answer_q: "Answer Question",
    create_offer: "Create Offer",
    pin_to_live: "Pin to Live",
    end_live: "END LIVE",
    approve_send: "Approve & Send",
    create_lead: "Create Lead",
    ai_reply: "AI Suggested Reply",
    generate_clips: "Generate Clips",
    hook_score: "Hook Score",
    scan_qr: "Scan for Live Promo",
    your_name: "Your Name",
    phone: "Phone / WhatsApp",
    claim: "Claim Promo",
    most_popular: "MOST POPULAR",
    subscribe: "Subscribe",
    current_plan: "Current Plan",
    seats_remaining: "Seats Remaining",
    stock: "Stock",
    intent: "Intent",
    invite_guest: "Invite Guest",
    add_source: "Add Source",
    destinations: "Destinations",
  },
  bm: {
    tagline: "Siar. Libat. Jual.",
    hero_title: "Jadikan Setiap Live Sebagai Revenue",
    hero_sub: "Yes Go Live menggabungkan studio siaran browser, AI Producer, live commerce, komen bersatu dan CRM lead attribution — satu platform untuk go live dan convert.",
    go_live: "GO LIVE SEKARANG",
    get_started: "Mula Percuma",
    login_google: "Teruskan dengan Google",
    nav_command: "Live Command",
    nav_studio: "Studio Console",
    nav_clips: "AI Clips",
    nav_battle: "Sales Battle",
    nav_leads: "Leads / CRM",
    nav_analytics: "Analitik",
    nav_pricing: "Harga",
    logout: "Log Keluar",
    live_now: "Sedang Live",
    total_viewers: "Jumlah Penonton",
    engagement: "Penglibatan",
    leads: "Leads",
    sales: "Jualan",
    revenue: "Revenue",
    host_performance: "Prestasi Host",
    revenue_7d: "Revenue (7 hari)",
    active_sessions: "Sesi",
    open_studio: "Buka Studio",
    new_studio: "Studio Baru",
    enter_studio: "MASUK STUDIO",
    prelive_lobby: "Lobi Pra-Live",
    camera: "Kamera",
    microphone: "Mikrofon",
    speaker: "Speaker",
    mic_level: "Paras Mic",
    echo: "Echo Cancellation",
    noise: "Noise Suppression",
    gain: "Auto Gain",
    scenes: "Scene",
    ai_producer: "OTO AI Producer",
    ask_ai: "Tanya AI Producer",
    comments: "Komen Live",
    commerce: "Live Commerce",
    audio_mixer: "Audio Mixer",
    show_product: "Papar Produk",
    show_cta: "Papar CTA",
    answer_q: "Jawab Soalan",
    create_offer: "Cipta Tawaran",
    pin_to_live: "Pin ke Live",
    end_live: "TAMAT LIVE",
    approve_send: "Lulus & Hantar",
    create_lead: "Cipta Lead",
    ai_reply: "Cadangan Jawapan AI",
    generate_clips: "Jana Clips",
    hook_score: "Skor Hook",
    scan_qr: "Imbas untuk Promo Live",
    your_name: "Nama Anda",
    phone: "Telefon / WhatsApp",
    claim: "Tuntut Promo",
    most_popular: "PALING POPULAR",
    subscribe: "Langgan",
    current_plan: "Pelan Semasa",
    seats_remaining: "Baki Tempat",
    stock: "Stok",
    intent: "Intent",
    invite_guest: "Jemput Tetamu",
    add_source: "Tambah Sumber",
    destinations: "Destinasi",
  },
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("otosubs_lang") || "en");
  useEffect(() => { localStorage.setItem("otosubs_lang", lang); }, [lang]);
  const t = (k) => (STR[lang] && STR[lang][k]) || STR.en[k] || k;
  const toggle = () => setLang((l) => (l === "en" ? "bm" : "en"));
  return <LangCtx.Provider value={{ lang, setLang, toggle, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
